<div class="storm-report-table">
  <table
    mat-table
    matSort
    matSortDisableClear
    [dataSource]="dataSource"
    (matSortChange)="sortChangedEvent.emit()"
    (scroll)="onScroll($event)"
    matSortActive="id"
    matSortDirection="desc"
    class="ops-table"
  >

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="id" class="mat-body">
        ID
      </th>
      <td mat-cell *matCellDef="let element">
        @if (element.statusTrack !== StormDataStatus.COMPLETED || element.statusLocation !== StormDataStatus.COMPLETED) {
          {{ element.id }}
        } @else {
          <a [routerLink]="['../', InsightsRoute.STORM_DETAIL, element.id]" class="ops-link">{{ element.id }}</a>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="mat-body">
        Name
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="startTime">
      <th mat-header-cell
          *matHeaderCellDef
          class="mat-body"
      >
        Storm Start
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.startTime | date: 'medium' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="endTime">
      <th mat-header-cell
          *matHeaderCellDef
          class="mat-body"
      >
        Storm End
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.endTime | date: 'medium' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell
          *matHeaderCellDef
          class="mat-body"
      >
        Duration
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.durationInSeconds | duration }}
      </td>
    </ng-container>

    <ng-container matColumnDef="locationStatus">
      <th mat-header-cell
          *matHeaderCellDef
          class="mat-body"
      >
        Location Data
      </th>
      <td mat-cell *matCellDef="let element"
          [matTooltip]="getLocationDataTooltip(element)"
      >
        {{ element.statusLocation }}
      </td>
    </ng-container>

    <ng-container matColumnDef="trackStatus">
      <th mat-header-cell
          *matHeaderCellDef
          class="mat-body"
      >
        Track Data
      </th>
      <td mat-cell *matCellDef="let element"
          [matTooltip]="getTrackDataTooltip(element)"
      >
        {{ element.statusTrack }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="openStormDetail(row)"
    ></tr>
  </table>
</div>
